
import React from 'react';
import { AccountState } from "../constants";
import { FlowRender } from "../flow-render";
import {adminSendConfirmationEmail, sendConfirmationEmail} from "../../client/onboarding/actions";
import {is_ira_rollover, is_transfer, get_payment_choice } from "../onboarding-utils";
import { sprintf } from "sprintf-js";
import {Action, Spinner, TextLoading} from "../../client/funcs/utils";
import {MailDepositBody} from "../../client/components/PaymentsDashboard/mail-deposits-card";
import {deep_copy} from "../js-utils";

class SigningDone extends FlowRender {

  constructor() {
    super();
    this.url = "signing_done";
  }

  init(componentState, appState) {
    componentState.sms_code = "";
    componentState.is_sending_email = false;
    componentState.is_verifying = false;
    componentState.is_resending = false;
  }

  canNavigateNext(component) {
    return component.getRootUrl() + "/payment_source";
  }

  getMicroDepPaymentId = component => {
    let query = component.getPathQuery();
    if (!query.startsWith("?microdeposit_initiated=")) {
      return "";
    }
    const segments = query.split("=");
    return segments[1];
  };

  getPaymentAccountName = (component, payment_id) => {
    if (!payment_id) {
      return "";
    }
    const dwolla = component.getDwollaData(0);
    return payment_id in dwolla.funding_source
      ? dwolla.funding_source[payment_id].name
      : "undefined";
  }

  onMount(component) {
    const args = component.getPathArgs();
    if (args.event === "cancel") {
      component.props.navigatePath(component.getRootUrl() + "/summary");
      return;
    }
    if (args.event === "signing_complete") {
      component.writeEnvelopeSigned();
    }
    
    const onboarding = component.getOnboardingData(component.props);
    const do_onboarding_transfer = is_transfer(onboarding);
    const is_proxy_onboarding = args.account_state === AccountState.ONBOARDING_PROXY;
    const set_live_state = do_onboarding_transfer
      || is_proxy_onboarding
      || is_ira_rollover(onboarding)
      || get_payment_choice(onboarding) === "fund_later"
      || get_payment_choice(onboarding) === "fund_check"
      || get_payment_choice(onboarding) === "fund_wire";

    component.setState({
      is_sending_email: true,
      going_live: true,
    });

    const email_promise = is_proxy_onboarding
      ? adminSendConfirmationEmail(
        component.props.token,
        component.getOnboardingIndex(),
        set_live_state,
        args.username)
       : sendConfirmationEmail(
         component.props.token,
         component.props.onboarding_token,
         component.getOnboardingIndex(),
         set_live_state);

    email_promise.then(result => {
        component.setState({
          is_sending_email: false,
          going_live: false,
        });
        const data = result.body.data;
        if (args.account_state && args.account_state !== data.account_state) {
          const new_args = deep_copy(args);
          new_args.account_state = data.account_state;
          console.log("navigate", component.props.path, new_args);
          component.props.navigatePath(component.props.path, new_args);
        }

        if (data.success) {
          if (data.account_state) {
            component.props.setAccountState(
              data.account_state, data.index);
          }
          if (data.onboarding) {
            component.props.setOnboardingData(
              data.onboarding, data.index);
          }
          if (do_onboarding_transfer) {
            component.onGoLive(is_proxy_onboarding).then();
          }
        }
      })
  }

  maybeRenderNextButton = component => {
    const account_state = component.getAccountState();
    if (account_state !== AccountState.VERIFIED) {
      return null;
    }
    const style = {
      marginTop: "2rem",
    };

    return (
      <div style={style}>
        { this.renderNextButton(component, {}, false) }
      </div>
    );
  };

  maybeRenderMicroDeposit = component => {
    const payment_id = this.getMicroDepPaymentId(component);
    if (!payment_id) {
      return null;
    }
    const acct_name = this.getPaymentAccountName(component, payment_id);

    const text = sprintf(
      "In the next few days, we will notify you of a micro-deposit made to your %s "
      + "account. We use this to verify you and your account information.",
      acct_name);

    return (
      <div>
        <div style={{ fontSize: "1.5rem"}}>{text}</div>
        <div style={{height: "1rem"}}/>
      </div>
    );
  }

  maybeRenderCheckInstructions = (component, onboarding) => {
    const do_check = is_ira_rollover(onboarding)
      || get_payment_choice(onboarding) === "fund_check";

    if (!do_check) {
      return null;
    }

    return (
      <div align={"left"}>
        <MailDepositBody
          component={component}/>
      </div>
    );
  };

  maybeRenderRolloverInstructions = onboarding => {
    if (!is_ira_rollover(onboarding)) {
      return null;
    }

    const text = "Rollovers can take anywhere from 5 to 10 days. "
      + "Check your email for important account status updates "
      + "as well as address information to mail a check in order "
      + " to fund your account";

    return (
      <div>
        <p>{text}</p>
        <div style={{height: "2rem"}}/>
      </div>
    );
  }

  maybeRenderTransferInstructions = onboarding => {
    if (!is_transfer(onboarding)) {
      return null;
    }
    const text = "Account transfers can take anywhere from 5 to 10 "
      + "days.  Check your email for important account status updates.";
    return (
      <div>
        <p>{text}</p>
        <div style={{height: "2rem"}}/>
      </div>
    )
  }

  maybeRenderNavToSAButton = component => {
    const args = component.getPathArgs();
    const is_proxy_onboarding = args.username;
    let nav_url;
    let nav_args = {};
    let text;

    if (!is_proxy_onboarding) {
      nav_args.acct_index = sprintf("%d", component.getOnboardingIndex());
      nav_url = "/user";
      text = "Go to your dashboard";
    } else {
      nav_url = "/" + component.props.path.split("/")[1] + "/user";
      text = "Back to Admin Dashboard";
    }
    const nav_back = () => {
      //const url = "/" + component.props.path.split("/")[1] + "/user";
      component.props.navigatePath(nav_url, nav_args);
    }

    return (
      <div align={"center"}>
        <Action onClick={nav_back}>
          {text}
        </Action>
      </div>
    )
  }

  maybeRenderAddAccountButton = component => {
    const is_sending_email = component.state.is_sending_email;
    const account_state = component.getAccountState();
    if (is_sending_email
      || (account_state !== AccountState.SIGNED
        && account_state !== AccountState.LIVE)) {
      return null;
    }

    if (component.getPathArgs().username) {
      return null;
    }

    const is_adding_account = component.state.adding_account;

    return (
      <div align={"center"} style={{marginBottom: "2rem"}}>
        <Action
          id={"add_another_account"}
          onClick={component.onAddAccount}
          disabled={is_adding_account}>
          <TextLoading
            label={"Add Another Account"}
            loading={is_adding_account}/>
        </Action>
      </div>
    )
  }

  maybeRenderMessage2 = component => {
    const is_sending_email = component.state.is_sending_email;
    const account_state = component.getAccountState();
    const onboarding = component.getOnboardingData(component.props);
    const args = component.getPathArgs();
    const is_proxy_onboarding = !!args.username;
    const no_envelope = onboarding.electronic_signing_type === "no_envelope";

    if (is_sending_email
      || (account_state !== AccountState.SIGNED
        && account_state !== AccountState.LIVE)
      || Object.keys(component.getOnboardingData(component.props)).length === 0) {
      return null;
    }

    const text_0 = "You got started today, and now we'll start investing for your tomorrow.";
    const text_1 = sprintf("An email confirming your new account information " +
      " has been sent to %s. Your account is being reviewed and should be opened shortly.",
      onboarding.role_0_email);
    const text_2 = "We'll send a notification as soon as its ready."
    const proxy_text = sprintf(
      "Email confirming new account information as been sent to %s", onboarding.role_0_email);
    const proxy_no_envelope_text = sprintf("%s has been activated.", onboarding.role_0_email);
    let body_text;
    if (is_proxy_onboarding) {
      if (no_envelope) {
        body_text = proxy_no_envelope_text;
      } else {
        body_text = proxy_text;
      }
    } else {
      body_text = text_1;
    }

    const larger = {
      fontSize: "1.5rem",
    }
    return (
      <div align={"center"}>
        <div>
          <span style={larger}>{text_0}</span>
        </div>
        <div style={{paddingTop: "2rem", paddingBottom: "2rem"}}>
          <span>{body_text}</span>
        </div>
        <div>
          <span style={larger}>{text_2}</span>
        </div>
      </div>
    )
  }

  renderBody = component => {
    const is_sending_email = component.state.is_sending_email;
    const done_title = "Congratulations";


    return (
      <div>
        <div align={"center"}>
          <div style={{fontSize: "2.5rem"}}>{done_title}</div>
          <div style={{height: "2rem"}}/>
          { is_sending_email && <Spinner size={"4rem"}/> }
          { this.maybeRenderMessage2(component) }
          <div style={{height: "1rem"}}/>
          { this.maybeRenderNavToSAButton(component)}
        </div>
      </div>
    )
  };

  render = component => {
    return this.renderSingleColumn(
      this.renderBody(component, "50%"));
  }
}

export { SigningDone };
